module.exports = "/cyber/_next/static/images/BannerMobileFOG-f339b9631e20f25f98edc7f0b0f1eac7.jpg";